const H = {
  name: "Cambodia",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10.323 3H13.677L15.3999 7.30713L16.3227 5H19.6768L21.9998 10.8074V19H19.9998V16H18V14H19.9998V12H16V21H14V16H12V14H14V12H10V21H8V16H6V14H8V12H4V19H2V10.8074L4.32297 5H7.67703L8.6 7.30742L10.323 3ZM4.47703 10H7.52297L6.32297 7H5.67703L4.47703 10ZM10 10H14V9.19258L12.323 5H11.677L10 9.19258V10ZM16.4768 10H19.5227L18.3227 7H17.6768L16.4768 10Z" fill="currentColor"/>
</svg>
  `
};
export {
  H as Cambodia
};
